/*
 * @Description: '联系我们'页面所有请求
 * @Author: QL2020
 * @Date: 2021-12-24 19:19:23
 * @LastEditTime: /
*/

import * as http from './base'

/**
 * 获取 联系我们
 */
const getContact = () => {
  return http.get('/os/contact',)
}




export default{ getContact }


// WEBPACK FOOTER //
// ./src/http/contact.js